var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 512,
    viewBox: "0 0 467 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.33 207.07L368.81 195.86V85.74C368.81 38.47 330.49 0.0100117 283.39 0.0100117H85.42C38.32 1.17155e-05 0 38.46 0 85.73V441.7C0 480.46 31.42 511.99 70.05 511.99H396.57C435.2 511.99 466.62 480.56 466.62 441.94V286.07C466.62 268.12 460.92 251.04 450.15 236.68C439.38 222.32 424.57 212.08 407.33 207.06V207.07ZM40 441.71V85.73C40 60.51 60.37 40 85.42 40H283.4C308.44 40 328.82 60.52 328.82 85.73V184.21L269.69 167C244.6 159.7 218.21 164.5 197.31 180.19C176.41 195.88 164.42 219.86 164.42 246V471.99H70.07C53.5 471.99 40.02 458.4 40.02 441.7L40 441.71ZM426.62 441.95C426.62 458.52 413.14 472 396.57 472H335.51V417.48C335.51 406.43 326.56 397.48 315.51 397.48C304.46 397.48 295.51 406.43 295.51 417.48V472H204.4V246.01C204.4 232.58 210.56 220.25 221.3 212.19C232.04 204.13 245.6 201.66 258.49 205.41L396.14 245.47C414.08 250.69 426.61 267.39 426.61 286.07V441.94L426.62 441.95Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 466.62,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCom);
export default __webpack_public_path__ + "static/media/com.24832f414b07a822669f15463f77393d.svg";
export { ForwardRef as ReactComponent };